import React from 'react';
import { useTheme } from '../context/ThemeContext';
import { FaSun, FaMoon } from 'react-icons/fa';
import NotificationDropdown from './NotificationDropdown';
import './ThemeToggle.css';

const ThemeToggle = () => {
  const { toggleTheme, isDarkMode } = useTheme();

  return (
    <div className="theme-toggle">
      <NotificationDropdown />
      <button 
        onClick={toggleTheme} 
        aria-label={`Switch to ${isDarkMode ? 'light' : 'dark'} mode`}
        title={`Switch to ${isDarkMode ? 'light' : 'dark'} mode`}
        className={isDarkMode ? 'dark' : 'light'}
      >
        {isDarkMode ? <FaSun /> : <FaMoon />}
        <span>{isDarkMode ? '' : ''}</span>
      </button>
    </div>
  );
};

export default ThemeToggle; 